export const contactObj = {
	FaceBook: "https://www.facebook.com/BlinceHydraulics",
	instagram: "https://www.instagram.com/blincehydraulic0099",
	Youtube: "https://www.youtube.com/@blincehydraulic/videos",
	Linkedin: "https://www.linkedin.com/company/blince",
};

export const contactInfo = {
	email: "sales16@blince.com",
	phone: "+86 - 76985156586",
	whatsapp: "+86-13242321601",
	wechat: "+86-13242321601",
	address: "No 35, Jinda Road, Humen Town, Dongguan City, Guangdong Province, China",
	name: process.env.NEXT_PUBLIC_COMPANY_NAME,
};
